import Vue from 'vue';
import VueRouter from 'vue-router';

import AppBase from './ui/AppBase';
import HomePage from './pages/home/HomePage';
import LoginPage from './pages/login/LoginPage';
import store from './store';
import { DetailedAnalytics } from './pages/detailed_analytics';
import { OverallAnalytics } from './pages/overall_analytics';
import { auth } from './firebase';
import * as Admin from './pages/admin';
import * as Challenges from './pages/challenges';
import * as Concepts from './pages/concepts';
import * as DailyChallenges from './pages/daily_challenges';
import * as Flows from './pages/flows';
import * as Functions from './pages/functions';
import * as Groups from './pages/groups';
import * as Notifications from './pages/settings/notifications';
import * as Orders from './pages/orders';
import * as Settings from './pages/settings/system';
import * as Topics from './pages/topics';
import * as Users from './pages/users';

Vue.use(VueRouter);

function isLoggedIn() {
  const { dispatch, state } = store;
  const user = auth.currentUser;

  // Reroutes user to login page if he is not already logged in
  if (user) {
    // No email means that user doc ref hasn't yet been bound to store
    if (!state.auth.user.email) {
      dispatch('auth/setUserRef', user.uid);
    }
    return true;
  }
  return false;
}

const routes = [
  {
    path: '/',
    component: AppBase,
    children: [
      {
        path: '/',
        redirect: '/home'
      },
      {
        path: '/home',
        name: 'home',
        component: HomePage
      },
      {
        path: '/overall-analytics',
        name: 'overall-analytics',
        component: OverallAnalytics
      },
      {
        path: '/detailed-analytics',
        name: 'detailed-analytics',
        component: DetailedAnalytics
      },
      {
        path: '/flows',
        name: 'flows',
        component: Flows.ListPage
      },
      {
        path: '/flows/new',
        name: 'add-flow',
        component: Flows.AddPage
      },
      {
        path: '/flows/edit/:id',
        name: 'edit-flow',
        component: Flows.EditPage
      },
      {
        path: '/topics',
        name: 'topics',
        component: Topics.ListPage
      },
      {
        path: '/topics/new',
        name: 'add-topic',
        component: Topics.AddPage
      },
      {
        path: '/topics/edit/:id',
        name: 'edit-topic',
        component: Topics.EditPage
      },
      {
        path: '/concepts',
        name: 'concepts',
        component: Concepts.ListPage
      },
      {
        path: '/concepts/new',
        name: 'add-concept',
        component: Concepts.AddPage
      },
      {
        path: '/concepts/edit/:id',
        name: 'edit-concept',
        component: Concepts.EditPage
      },
      {
        path: '/concepts/versions/:id',
        name: 'versioned-concept',
        component: Concepts.VersionsPage
      },
      {
        path: '/challenges',
        name: 'challenges',
        component: Challenges.ListPage
      },
      {
        path: '/challenges/new',
        name: 'add-challenge',
        component: Challenges.AddPage
      },
      {
        path: '/challenges/edit/:id',
        name: 'edit-challenge',
        component: Challenges.EditPage
      },
      {
        path: '/challenges/:id/attempts',
        name: 'challenge-attempts',
        component: Challenges.Attempts.ListPage
      },
      {
        path: '/challenge_attempts/:id/review',
        name: 'challenge-attempts-review',
        component: Challenges.Attempts.ReviewPage
      },
      {
        path: '/groups',
        name: 'groups',
        component: Groups.ListPage
      },
      {
        path: '/groups/new',
        name: 'add-group',
        component: Groups.AddPage
      },
      {
        path: '/groups/edit/:id',
        name: 'edit-group',
        component: Groups.EditPage
      },
      {
        path: '/daily_challenges',
        name: 'daily_challenges',
        component: DailyChallenges.ListPage
      },
      {
        path: '/daily_challenges/new',
        name: 'add-daily_challenges',
        component: DailyChallenges.AddPage
      },
      {
        path: '/users',
        name: 'users',
        component: Users.ListPage
      },
      {
        path: '/users/:id/classes',
        name: 'user-classes',
        component: Users.Classes.ListPage
      },
      {
        path: '/users/:id/daily_challenges',
        name: 'user-daily-challenges',
        component: Users.DailyChallenges.DetailsPage
      },
      {
        path: '/admin',
        name: 'admin',
        component: Admin.ListPage
      },
      {
        path: '/orders',
        name: 'orders',
        component: Orders.ListPage
      },
      {
        path: '/orders/new',
        name: 'add-order',
        component: Orders.AddPage
      },
      {
        path: '/functions',
        name: 'functions',
        component: Functions.ListPage
      },
      {
        path: '/settings',
        name: 'settings',
        component: Settings.EditPage
      },
      {
        path: '/notifications',
        name: 'notifications',
        component: Notifications.EditPage
      }
    ],
    beforeEnter: (to, from, next) => {
      // Reroutes user to login page if he is not already logged in
      return isLoggedIn() ? next() : next('/login');
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    beforeEnter: (to, from, next) => {
      return isLoggedIn() ? next('/') : next();
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
